import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { fetchNews } from 'src/core/redux/action/newsAction'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import NewsCardFeatured from 'src/shared/News/NewsCardFeatured'
import NewsCard from 'src/shared/News/NewsCard'
import { fetchEnterprise } from 'src/core/redux/action/enterpriseInfosAction'
import { Fender } from 'src/shared/Fender/Fender'
import DashboardPanel from 'src/page/Consumer/Dashboard/DashboardPanel'
import DashboardLoading from 'src/page/Consumer/Dashboard/DashboardLoading'

const styles = (t: Theme) => createStyles({
  newWpr: {
    margin: `${t.spacing.unit * 2}px 0`,
    padding: '0 1px'
  },
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
}

interface IState {
  isFetching: boolean;
}

class DashboardNews extends React.Component<IProps, IState> {
  state = {
    isFetching: false
  }

  componentDidMount(){
    const {fnews, promisesWithProgress, toastError} = this.props
    this.setState({isFetching: true})
    promisesWithProgress(
      fnews({limit: 3, offset: 0, order_by: 'desc', sort_by: 'publish_at', is_highlighted: false} as NewsCriteria).catch(err => toastError(err.msg)).finally(() => this.setState({isFetching: false})),
    )
  }

  render() {
    const {t, classes, news} = this.props
    const {isFetching} = this.state
    return (
        <DashboardPanel
            label={t.on_the_front_page}
            icon="notifications"
            redirect="eco-watch"
            headerClickableRedirectOnly
            noShadow={true}
        >
          {isFetching && <DashboardLoading />}
          {(news && news.length > 0 && !isFetching) &&
              <>
                <NewsCardFeatured pathNews={this.props.match.path} criteria={{}}/>
                {news.map(n => {
                    return (
                        <div key={`news-wpr-${n.id}`} className={classes.newWpr}>
                            <NewsCard key={`news-${n.id}`} entity={n} pathNews={this.props.match.path} withChip={true}/>
                        </div>
                    )
                    })
                }
              </>
          }
          {(news && news.length === 0 && !isFetching) && 
            <Fender text={t.Dashboard_no_news} />
          }
        </DashboardPanel>
    )
  }
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  news: state.paginate.news.entities,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
});

const dispatch2props = (dispatch: any) => ({
  fetchEnterprise: (id: string) => dispatch(fetchEnterprise(id)),
  fnews: (c: NewsCriteria) => dispatch(fetchNews(c)),
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(DashboardNews)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/tabs/DashboardNews.tsx